import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  adaptorsSectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  channelsSectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  buttons: {
    display: 'flex',
    flexDirection: 'row'
  },
  adaptorsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    columnGap: 16,
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr 1fr ',
      columnGap: 8
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr'
    }
  },
  channelsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    columnGap: 16,
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr 1fr ',
      columnGap: 8
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr'
    }
  }
}))

export default useStyles
